import { Component, OnInit, ViewChild, HostListener, OnDestroy, DoCheck } from '@angular/core';
import { AppSettings, Settings } from '../app.settings';
import { Router, NavigationEnd } from '@angular/router'; 
import { MenuService } from './components/menu/menu.service';
import { Menu } from './components/menu/menu.model';
import { LoginserviceService } from '../services/loginservice.service';
import { HostService } from '../services/host.service';
import { AuthService } from '../services/auth.service';
import { SocketService } from '../services/socket.service';
import { Subscription } from 'rxjs';
import { MessageService } from '../services/message.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-compte-utilisateur",
  templateUrl: "./compte-utilisateur.component.html",
  styleUrls: ["./compte-utilisateur.component.scss"],
})
export class CompteUtilisateurComponent implements OnInit, OnDestroy, DoCheck {
  @ViewChild("sidenav") sidenav: any;
  public settings: Settings;
  public menuItems: Array<Menu> = [];
  public toggleSearchBar: boolean = false;
  public userImage: any;
  mailSnippets: string[] = [];
  public userDetails: any;
  src: any;
  blockMenuUser: boolean;
  UserImage :any;
  [x: string]: any;

  public userIn: any;
  public item: any;
  public messages: Array<any> = [];

  //subscripion
  messageSubscription: Subscription
  
  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private getHost: HostService,
    private menuService: MenuService,
    public loginService: LoginserviceService,
    private authService: AuthService,
    private socketService: SocketService,
    private messageService: MessageService,
    private toastr: ToastrService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {

      if (window.innerWidth <= 960) {
        this.settings.adminSidenavIsOpened = false;
        this.settings.adminSidenavIsPinned = false;
      }
      this.menuItems = this.menuService.getMenuItems();
  
      this.src = this.getHost.getHttpsImage();
        
      //recuperer image et les data pour afficher
      if ((this.authService.isLoggedIn) && (this.blockMenuUser = true)){

          const storageAuth = localStorage.getItem("user");

          if(storageAuth) {
            
            this.userDetails = JSON.parse(storageAuth!);
          
            if (this.userDetails.user_image == null) {

              this.elementImage = false

              this.UserImage = 'assets/images/avatars/avatar-2.png'

            }else {

              this.UserImage = this.userDetails.user_image;

              this.elementImage = true

              // window.location.reload();
            }

            this.getMessage();

            this.webSocket();

          } else {

            this.blockMenuUser = false

          }
          

      } else {

        this.blockMenuUser = false

      }

  }

  private getMessage() {

    this.messageSubscription = this.messageService.fetchAllUnreadMessagesOfUser(this.userDetails.id).subscribe((response: any) => {

      this.messages = response.messages;

    })

  }

  private webSocket() {

    let pusher = this.socketService.initSocket();

    var channel = pusher.subscribe('channel-notification-message');
    
    channel.bind('notification-message', (response : any) => {

        if(response.message.status == 0) {

          if(response.message.receiver_id == this.userDetails.id) {

            this.messages.push(response.message)
  
          }

        } else {

          let currentMessage = this.messages.filter((message: any) => message.renting_id != response.message.renting_id);

          this.messages = currentMessage;

        }
         
    });
    
  } 
  
  logout(): void {
    
    this.authService.logout();

  }

  ngAfterViewInit() {
    if (document.getElementById("preloader")) {
      document.getElementById("preloader")?.classList.add("hide");
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
      if (window.innerWidth <= 960) {
        this.sidenav.close();
      }
    });
    this.menuService.expandActiveSubMenu(this.menuService.getMenuItems());
  }

  public toggleSidenav() {
    this.sidenav.toggle();
  }

  public scrollToTop() {
    var scrollDuration = 200;
    var scrollStep = -window.pageYOffset / (scrollDuration / 20);
    var scrollInterval = setInterval(() => {
      if (window.pageYOffset != 0) {
        window.scrollBy(0, scrollStep);
      } else {
        clearInterval(scrollInterval);
      }
    }, 10);
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      });
    }
  }

  @HostListener("window:resize")
  public onWindowResize(): void {
    if (window.innerWidth <= 960) {
      this.settings.adminSidenavIsOpened = false;
      this.settings.adminSidenavIsPinned = false;
    } else {
      this.settings.adminSidenavIsOpened = true;
      this.settings.adminSidenavIsPinned = true;
    }
  }

  ngOnDestroy(): void {
    
    this.messageSubscription.unsubscribe();

  }

  changeTypeAccount(){
    const storageAuth = localStorage.getItem("user");
    this.userDetails = JSON.parse(storageAuth!);
    this.userDetails.roleApp = this.userDetails.roleApp ==="locataire" ? "proprietaire" : "locataire";
    localStorage.setItem('user', JSON.stringify(this.userDetails));
    this.toastr.success("Vous êtes connecté en tant que "+this.userDetails.roleApp);
    this.router.navigate(['/compte-utilisateur']);
  }

  ngDoCheck(){
    this.menuItems = this.menuService.getMenuItems();
  }
}
